import { useEffect, RefObject } from 'react';
/**
 * React hook that triggers a callback function when an element
 * is click outside the reference element
 *
 * @param ref - Is a react reference object
 * @param callback - Function that gets called
 *
 */
export function useOutsideClick(
	ref: RefObject<any>,
	callback: Function,
	ignoreId: string,
) {
	useEffect(() => {
		if (!ref) {
			return;
		}
		/**
		 * Alert if clicked on outside of element
		 */
		function handleClickOutside(event: MouseEvent) {
			const target: any = event.target;

			if (ref.current && !ref.current.contains(event.target)) {
				if (ignoreId && event.target && ignoreId === target.id) {
					return;
				}
				callback(event);
			}
		}
		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ref, callback]);
}
